module.exports = __webpack_public_path__ + "static/media/placeholder7.436ad69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder7.jpg
// module id = 629
// module chunks = 0